export default "__VITE_ASSET__BuRgFM9J__"